



















import { Component, Vue, Prop } from 'vue-property-decorator';
import { CURRENCY_FORMAT } from '@/helpers/currency';
import Datagrid from '@/components/default/Datagrid.vue';
import notificationService from '@/services/notificationService';
import projectsRepository from '@/services/projectsRepository';

@Component({
  components: {
    Datagrid,
  },
})
export default class ProjectCostsTable extends Vue {
    @Prop({required: true})
    project!: any;

    initialised: boolean = false;

    private mounted() {
        if (this.project && !this.project.projectCosts) {
            this.project.projectCosts = [];
        }

        this.initialised = true;
    }

    private addRow() {
        ((this.$refs.grid as Vue).$refs.ProjectsCostsGrid as any).instance.addRow();
    }

    save(e: any) {
        const self = this;
        e.cancel = new Promise(async (resolve, reject) => {
            try {
                await projectsRepository.updateCosts({
                    projectId: self.project.id,
                    projectCosts: self.project.projectCosts,
                });
                notificationService.saved();
                resolve(false);
            } catch (err) {
                notificationService.showAxiosError(err);
                resolve(true);
            }
        });
    }

    get columns() {
        const columns: any[] = [
            {
                dataField: 'description',
                caption: 'Beschrijving',
            },
            {
                dataField: 'amount',
                caption: 'Bedrag',
                dataType: 'number',
                format: CURRENCY_FORMAT,
                alignment: 'left',
            },
            {
                dataField: 'type',
                caption: 'Type',
                lookup: {
                    dataSource: [
                        { value: 0, text: 'Materiaal' },
                        { value: 1, text: 'Arbeid' },
                        { value: 2, text: 'Ander' },
                    ],
                    valueExpr: 'value',
                    displayExpr: 'text',
                },
            }
        ];

        if (!this.project.isOnHold) {
            columns.push({
                type: 'buttons',
                buttons: ['edit', 'delete'],
            });
        }

        return columns;
    }

    get toolbarOptions() {
        return [
            {
                location: 'before',
                widget: 'dxButton',
                options: {
                icon: 'fas fa-plus',
                text: 'Toevoegen',
                stylingMode: 'outlined',
                type: 'success',
                onClick: () => {
                        this.addRow();
                    },
                },
                disabled: this.project.isOnHold
            },
        ];
    }
}
